import React, {Component} from 'react';
import './App.css';


import Index from "./pages/index";

import {HashRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import InnovativeModule from "./pages/Modules/Innovative";
import {Grid, Paper} from "@material-ui/core";
import CommercialModule from "./pages/Modules/Commercial";
import useStyles from "./components/useStyles";
import InnovativeModulePdf from "./pages/Modules/Innovative/pdf";
import InnovativeModuleQuiz from "./pages/Modules/Innovative/quiz";
import CommercialModulePdf from "./pages/Modules/Commercial/pdf";
import SecurityModule from "./pages/Modules/Security";
import SecurityModulePdf from "./pages/Modules/Security/pdf";
import SecurityModuleQuiz from "./pages/Modules/Security/quiz";
import ApplicationModule from "./pages/Modules/Application";
import ApplicationModulePdf from "./pages/Modules/Application/pdf";
import ApplicationModuleQuiz from "./pages/Modules/Application/quiz";
import CommercialModuleQuiz from "./pages/Modules/Commercial/quiz";
import Layout from "./pages/layout";
import LicensingModule from "./pages/Modules/Licensing";
import LicensingModulePdf from "./pages/Modules/Licensing/pdf";
import LicensingModuleQuiz from "./pages/Modules/Licensing/quiz";
import CreationModule from "./pages/Modules/Creation";
import CreationModulePdf from "./pages/Modules/Creation/pdf";
import CreationModuleQuiz from "./pages/Modules/Creation/quiz";
import ProcessModule from "./pages/Modules/Process";
import ProcessModulePdf from "./pages/Modules/Process/pdf";
import ProcessModuleQuiz from "./pages/Modules/Process/quiz";

const App = (
    {
        router,
    }
) => {
    const classes = useStyles();

    return (
        <p className={"App-header"}>
            <Grid container xs={12} alignItems={'center'}>
                <Grid container md={2}/>
                <Grid container xs={12} md={8} className={classes.grid}>
                    <Router>
                        <Layout>
                            <Switch>
                                <Route exact path={'/'} component={Index}/>

                                <Route exact path={'/modul/1/'} component={InnovativeModule}/>
                                <Route exact path={'/modul/1/pdf'} component={InnovativeModulePdf}/>
                                <Route exact path={'/modul/1/quiz/:page'} component={InnovativeModuleQuiz}/>

                                <Route exact path={'/modul/2/'} component={CommercialModule}/>
                                <Route exact path={'/modul/2/pdf'} component={CommercialModulePdf}/>
                                <Route exact path={'/modul/2/quiz/:page'} component={CommercialModuleQuiz}/>

                                <Route exact path={'/modul/3/'} component={SecurityModule}/>
                                <Route exact path={'/modul/3/pdf'} component={SecurityModulePdf}/>
                                <Route exact path={'/modul/3/quiz/:page'} component={SecurityModuleQuiz}/>

                                <Route exact path={'/modul/4/'} component={ApplicationModule}/>
                                <Route exact path={'/modul/4/pdf'} component={ApplicationModulePdf}/>
                                <Route exact path={'/modul/4/quiz/:page'} component={ApplicationModuleQuiz}/>

                                <Route exact path={'/modul/5/'} component={LicensingModule}/>
                                <Route exact path={'/modul/5/pdf'} component={LicensingModulePdf}/>
                                <Route exact path={'/modul/5/quiz/:page'} component={LicensingModuleQuiz}/>

                                <Route exact path={'/modul/6/'} component={CreationModule}/>
                                <Route exact path={'/modul/6/pdf'} component={CreationModulePdf}/>
                                <Route exact path={'/modul/6/quiz/:page'} component={CreationModuleQuiz}/>

                                <Route exact path={'/modul/7/'} component={ProcessModule}/>
                                <Route exact path={'/modul/7/pdf'} component={ProcessModulePdf}/>
                                <Route exact path={'/modul/7/quiz/:page'} component={ProcessModuleQuiz}/>

                                {/* Error handler */}
                                <Redirect to="/404"/>
                            </Switch>
                        </Layout>
                    </Router>
                </Grid>
            </Grid>
        </p>
    );
}

export default App;

